import Link from 'next/link';

import { TOURNAMENTS } from '~/constants';
import { useGameContext } from '~/contextProviders/GameContextProvider';

function BattleNav() {
  const { battle, totalRounds, setBattle } = useGameContext();
  const links: Array<any> = [];
  for (let i = 0; i < totalRounds; i++) {
    const label = `Round ${i + 1}`;
    links.push(
      <div
        className={`battle-nav__item
        ${battle === i ? ' battle-nav__item--active' : ''}
        ${totalRounds === 1 ? ' battle-nav__item--mobile-one-round' : ''}
        `}
        onClick={() => setBattle(i)}
        key={i}
      >
        <a className="battle-nav__link">
          {label}
        </a>
      </div>
    );
  }
  return (
    <>
      <div className="battle-nav battle-nav-tournament-sub-links">
        {links}
      </div>
      <div className="battle-nav-tournament-explainer">
        {/* <p className="grid-potions__text grid-potions__explainer">New Tournament every three weeks</p> */}
        <p className="grid-potions__text grid-potions__explainer">Cutoff 2:50 pm EST, results and next matchup posted at 3pm</p>
        <p className="grid-potions__text grid-potions__explainer">Battles every week day, full FAQ and schedule <a className="link" href="https://fictivekin.notion.site/Peacefall-Battle-FAQ-f7d9120ed5774babb34fd95c5f7cc306">here</a></p>
      </div>
    </>
  );
}

export default function BattleNavTournament() {
  const links: Array<any> = [];
  const { tournamentParam } = useGameContext();

  // eslint-disable-next-line guard-for-in
  for (const key in TOURNAMENTS) {
    const tournament = TOURNAMENTS[key];

    if (tournament.isShown) {
      const link = `/tournaments/battles/${tournament.id}`;

      links.push(
        <Link href={link} passHref key={tournament.id}>
          <div className="battle-nav__item-top">
            <button
              className={`button ${
                tournamentParam === tournament.id ? 'active' : ''
              }`}
              type="button"
            >
              {tournament.name}
            </button>
          </div>
        </Link>,
      );
    }
  }

  return (
    <>
      <div className="battle-nav battle-nav-tournament">{links}</div>
      <BattleNav />
    </>
  );
}
